var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1747_25760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7908 10.2132C20.7908 4.6154 16.253 0.0775146 10.6552 0.0775146C5.05742 0.0775146 0.519531 4.6154 0.519531 10.2132C0.519531 15.2721 4.22598 19.4653 9.07149 20.2257V13.143H6.49799V10.2132H9.07149V7.98016C9.07149 5.43991 10.5847 4.03676 12.8999 4.03676C14.0085 4.03676 15.1687 4.23472 15.1687 4.23472V6.72904H13.8907C12.6316 6.72904 12.2389 7.5104 12.2389 8.31274V10.2132H15.0499L14.6006 13.143H12.2389V20.2257C17.0844 19.4653 20.7908 15.2721 20.7908 10.2132Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1747_25760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2713,
    height: 20.2713,
    fill: "white",
    transform: "translate(0.519531 0.0775146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.30daa42143791bcc905188160279805a.svg";
export { ForwardRef as ReactComponent };